document.addEventListener('moved', (event) => {
    if ( event.target.matches('.liquidierbare_vermoegenswerte') ) {
        updateSortIdFields(event.target)        // Aktualisiere die Sort Ids der Elemente
    }
})

document.addEventListener('added', (event) => {
    if ( event.target.matches('.liquidierbare_vermoegenswerte') ) {
        updateDestroyFields(event.target, 0)    // Setze alle _destroy Input Felder auf 0
        updateSortIdFields(event.target)        // Aktualisiere die Sort Ids der Elemente
    }
})

document.addEventListener('added', (event) => {
    if ( event.target.matches('.nicht_liquidierbare_vermoegenswerte') ) {
        updateDestroyFields(event.target, 1)    // Setze alle _destroy Input Felder auf 1
    }
})

const updateDestroyFields = (vermoegenswerteContainer, updateWert) => {
    if ( vermoegenswerteContainer ) {
        const vermoegenswerte = vermoegenswerteContainer.querySelectorAll('.liquidierung_transaktion')

        vermoegenswerte.forEach( vm => {
            const destroyField = vm.querySelector('.remove_input')

            if ( destroyField ) destroyField.value = updateWert
        })
    }
}

const updateSortIdFields = (vermoegenswerteContainer) => {
    if ( vermoegenswerteContainer ) {
        const vermoegenswerte = vermoegenswerteContainer.querySelectorAll('.liquidierung_transaktion')

        vermoegenswerte.forEach( (vm, index) => {
            const sortierungIdInput = vm.querySelector('.sortierung_id_input')

            if ( sortierungIdInput ) sortierungIdInput.value = index + 1
        })
    }
}
